import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useAppContext } from "app/AppContext";
import { useFormApi } from "components/form";
import FormContent from "components/form/FormContent";
import React, { createRef, useEffect, useState } from "react";
import { Form } from "react-final-form";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function DefaultCrudForm({
    title,
    routeForm,
    backRoute,
    initialValues,
    setNewValues,
    saveValues,
    validValues,
    formActions,
    contentProps,
    children,
    EntityClass,
    setActionsOnTopView = true,
    t,
}) {
    const { i18n } = useTranslation();
    const form = useFormApi();
    const formRef = createRef();
    const [showConfirmClose, setShowConfirmClose] = useState(false);
    useEffect(() => {
        if (form) {
            form.ref = formRef;
        }
    }, [form, formRef]);

    const { useSetTitle, setActionsView } = useAppContext();
    const navigate = useNavigate();

    useEffect(() => {
        console.log('setActionsOnTopView',setActionsOnTopView)
        if (setActionsOnTopView) {



            const actions = [];

            if (formActions?.novo) {
                actions.push({
                    uid: "salvarForm",
                    text: t ? t("Salvar") : "Salvar",
                    iconName: "Check",
                    sequence: "20",
                    action: () => {
                        console.log("formApi", form);
                        form.submit();
                    },
                });
            }

            if (formActions?.novoForm) {
                actions.push({
                    uid: "novoForm",
                    text: t ? t("Novo") : "Novo",
                    iconName: "Add",
                    sequence: "10",
                    action: () => {
                        form.formProps.form.restart(EntityClass?.initialize);

                        // console.log("form.formProps.form", form.formProps.form)

                        setNewValues();
                        form.reset();
                        navigate("/" + routeForm);
                    },
                });
            }
            if (formActions?.salvarForm) {
                actions.push({
                    uid: "salvarForm",
                    text: t ? t("Salvar") : "Salvar",
                    iconName: "Check",
                    sequence: "20",
                    action: () => {
                        form.submit();
                    },
                });
            }
            if (formActions?.sairForm) {
                actions.push({
                    uid: "sairForm",
                    text: t ? t("Sair") : "Sair",
                    iconName: "Close",
                    sequence: "999999",
                    action: () => {
                        setShowConfirmClose(true);
                        // if (backRoute) {
                        //     navigate("/" + backRoute);
                        // } else {
                        //     navigate("/");
                        // }
                    },
                });
            }

            setActionsView(actions);

            return () => {
                setActionsView([]);
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [backRoute, form, navigate, routeForm, setActionsView, setNewValues, i18n.language]);

    useSetTitle(title);

    async function handleSubmit(values) {
        let continueSave = true;

        if (validValues) {
            continueSave = await validValues(values);
            console.log("continueSave", continueSave);
        }

        if (continueSave) {
            if (saveValues) {
                console.log("continueSave", continueSave);
                console.log("vai salvar");
                saveValues(values);
            } else {
                console.log("sem metodo de salvamento");
            }
        }
    }

    return (
        <Box sx={{ flex: 1 }}>
            <Form onSubmit={handleSubmit} initialValues={initialValues}>
                {(formProps) => {
                    form.formProps = formProps;
                    return (
                        <form ref={formRef} onSubmit={formProps.handleSubmit}>
                            <FormContent {...contentProps}>{children(formProps)}</FormContent>
                        </form>
                    );
                }}
            </Form>
            {showConfirmClose && (
                <Dialog
                    open={showConfirmClose}
                    keepMounted
                    onClose={() => setShowConfirmClose(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Sair"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            {`Deseja sair e perder toda informação não salva?`}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => {
                                if (backRoute) {
                                    navigate("/" + backRoute);
                                } else {
                                    navigate("/");
                                }
                            }}
                        >
                            Sim
                        </Button>
                        <Button onClick={() => setShowConfirmClose(false)}>Não</Button>
                    </DialogActions>
                </Dialog>
            )}
        </Box>
    );
}
